module.exports = __webpack_public_path__ + "static/media/loc6_img2.b3289121.jpg";